export default {
  trackingNumber: 'Tracking number',
  amount: 'Amount',
  cash: 'Cash',
  credit: 'Credit',
  internet: 'Internet',
  paymentMethod: 'Payment method',
  selectGateway: 'Select gateway',
  pleaseSelectGateway: 'Please select gateway',
  loadPaymentDescription: 'Order ID {loadId}',
  successfulPaymentMessage: 'Successful payment',
  failedPaymentMessage: 'Payment failed',
  payAndSubmitSuccessfulMessage: 'Your request submitted successfully',
  payAndSubmitFailedMessage:
    "Your request submitted as 'initial registration' because of failed payment",
  feePaid: 'Fee paid',
  bankTrackingNumber: 'Bank tracking number',
  loadDetail: 'Load detail',
  payAgain: 'Pay again',
  succesfulPayment: 'Successful payment',
  failedPayment: 'Failed payment',
  payOrder: 'Pay order',
  redirectingToPaymentGateway: 'Redirecting to payment gateway ...',
  internetPortal: 'Internet portal',
  orgPortal: 'ORG portal',
  giftCard: 'Gift card',
  enterYourGiftCard: 'Enter your gift card',
  orderAmount: 'Order amount',
  directBankTransfer: 'Direct bank transfer',
  payCredit: 'Increase wallet balance',
  balance: 'Balance',
  bankCredit: 'Bank credit',
  pay: 'Pay'
}
